module.exports = "<table dt-options=\"$ctrl.dtOptions\" class=\"table table-striped datatable-conduu\" style=\"width:100%\">\n  <thead>\n  <tr>\n    <th ng-repeat=\"column in $ctrl.dtSettings.data.columns\">{{column}}</th>\n  </tr>\n  </thead>\n  <tbody>\n  <tr ng-repeat=\"row in $ctrl.dtData\">\n    <td ng-repeat=\"cell in row track by $index\">{{cell}}</td>\n  </tr>\n  </tbody>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./client/~ap/components/suite-entity-datatable/suite-entity-datatable.component.html
// module id = 994
// module chunks = 0